module.exports = __webpack_public_path__ + "img/implants_x2.8d103562.png";